import { EventTicketsPropsType } from 'services/events/evetns.api.type';
import initialApiService from 'services/initialApiService';
import { TicketsFullInfoResponseType } from 'services/tickets/tickets.api.type';

import {
  EventCreatedType,
  EventTicketGroupReqType,
  EventTicketGroupResType,
  TicketCombinationResType,
} from 'types/events/eventTypes';

const ticketsApiService = initialApiService.injectEndpoints({
  endpoints: (build) => ({
    getTickets: build.query<void, { TakeLastDays: number }>({
      query: ({ TakeLastDays }) => ({
        url: `tickets/lastorders`,
        method: 'GET',
        params: {
          TakeLastDays,
        },
      }),
    }),
    getOrderFullInfo: build.query<TicketsFullInfoResponseType, string>({
      query: (id) => ({
        url: `tickets/order/${id}`,
        method: 'GET',
      }),
    }),
    addedTicketType: build.mutation<EventCreatedType, EventTicketsPropsType>({
      query: (data) => ({
        url: `events/tickettypes`,
        method: 'PATCH',
        body: data,
      }),
    }),
    deleteTicketType: build.mutation<EventCreatedType, string>({
      query: (id) => ({
        url: `events/tickettype/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TicketTypes'],
    }),
    addTicketGroup: build.mutation<EventTicketGroupResType[], EventTicketGroupReqType>({
      query: (data) => ({
        url: `events/tickettypegroup`,
        method: 'POST',
        body: data,
      }),
    }),
    editTicketGroup: build.mutation<EventTicketGroupResType[], EventTicketGroupReqType>({
      query: (data) => ({
        url: `events/tickettypegroup`,
        method: 'PATCH',
        body: data,
      }),
    }),
    deleteTicketGroup: build.mutation<EventTicketGroupResType[], string>({
      query: (id) => ({
        url: `events/tickettypegroup/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TicketTypeGroup'],
    }),
    deleteTicketGroupImage: build.mutation<EventTicketGroupResType[], string>({
      query: (id) => ({
        url: `events/tickettypegroupimage/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TicketTypeGroupImage'],
    }),
    getTicketGroups: build.query<EventTicketGroupResType[], string>({
      query: (id) => ({
        url: `/events/tickettypegroups/${id}`,
        method: 'GET',
      }),
    }),
    getTicketCombinations: build.query<TicketCombinationResType[], string>({
      query: (id) => ({
        url: `/events/tickettypecombinations/${id}`,
        method: 'GET',
      }),
    }),
    deleteTicketTypeCombination: build.mutation<TicketCombinationResType[], string>({
      query: (id) => ({
        url: `events/tickettypecombinations/${id}`,
        method: 'DELETE',
      }),
    }),
    addTicketTypeCombination: build.mutation<
      TicketCombinationResType[],
      { sourceTicketTypeId: string; destinationTicketTypeId: string }
    >({
      query: (data) => ({
        url: `events/tickettypecombinations`,
        method: 'POST',
        body: data,
      }),
    }),
    sendTicketToEmail: build.query<TicketsFullInfoResponseType, { OrderId: string; Email: string }>(
      {
        query: (params) => ({
          url: `tickets/email`,
          method: 'GET',
          params,
        }),
      },
    ),
  }),
});

export const {
  useLazyGetTicketsQuery,
  useLazyGetOrderFullInfoQuery,
  useLazySendTicketToEmailQuery,
  useAddedTicketTypeMutation,
  useLazyGetTicketCombinationsQuery,
  useDeleteTicketTypeCombinationMutation,
  useAddTicketTypeCombinationMutation,
  useDeleteTicketTypeMutation,
  useAddTicketGroupMutation,
  useEditTicketGroupMutation,
  useLazyGetTicketGroupsQuery,
  useDeleteTicketGroupMutation,
  useDeleteTicketGroupImageMutation,
} = ticketsApiService;
